import { render, staticRenderFns } from "./fieldLabel.vue?vue&type=template&id=3f7d2be7&"
import script from "./fieldLabel.vue?vue&type=script&lang=js&"
export * from "./fieldLabel.vue?vue&type=script&lang=js&"
import style0 from "./fieldLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports